// import { createBrowserRouter, redirect } from "react-router-dom";

// import AuthGuard from "./auth/AuthGuard";

// import dashboardRoutes from "./views/dashboard/dashboardRoutes";
// import pagesRoutes from "./views/pages/pagesRoutes";
// import iconsRoutes from "./views/icons/iconsRoutes";
// import formsRoutes from "./views/forms/formsRoutes";
// import chartsRoute from "./views/charts/chartsRoute";
// import uiKitsRoutes from "./views/ui-kits/uiKitsRoutes";
// import widgetsRoute from "./views/widgets/widgetsRoute";
// import dataTableRoute from "./views/data-table/dataTableRoute";
// import extraKitsRoutes from "./views/extra-kits/extraKitsRoutes";
// import chatRoutes from "./views/app/chat/chatRoutes";
// import inboxRoutes from "./views/app/inbox/inboxRoutes";
// import invoiceRoutes from "./views/app/invoice/invoiceRoutes";
// import contactRoutes from "./views/app/contact/contactRoutes";
// import calendarRoutes from "./views/app/calendar/calendarRoutes";
// import ecommerceRoutes from "./views/app/ecommerce/ecommerceRoutes";
// import taskManagerRoutes from "./views/app/task-manager/taskManagerRoutes";

// import Error404 from "./views/sessions/Error";
// import sessionsRoutes from "./views/sessions/sessionsRoutes";

// export const protectedRoutes = [
//   ...dashboardRoutes,
//   ...uiKitsRoutes,
//   ...formsRoutes,
//   ...widgetsRoute,
//   ...chartsRoute,
//   ...dataTableRoute,
//   ...extraKitsRoutes,
//   ...pagesRoutes,
//   ...iconsRoutes,
//   ...invoiceRoutes,
//   ...inboxRoutes,
//   ...calendarRoutes,
//   ...taskManagerRoutes,
//   ...ecommerceRoutes,
//   ...contactRoutes,
//   ...chatRoutes
// ];
// const routes = createBrowserRouter([
//   {
//     element: <AuthGuard />,
//     children: protectedRoutes
//   },
//   ...sessionsRoutes,
//   { path: "/", loader: () => redirect("/dashboard/v1") },
//   { path: "*", element: <Error404 /> }
// ]);

// export default routes;


// import { createBrowserRouter, redirect } from "react-router-dom";

// import AuthGuard from "./auth/AuthGuard";

// import dashboardRoutes from "./views/dashboard/dashboardRoutes";
// import pagesRoutes from "./views/pages/pagesRoutes";
// import iconsRoutes from "./views/icons/iconsRoutes";
// import formsRoutes from "./views/forms/formsRoutes";
// import chartsRoute from "./views/charts/chartsRoute";
// import uiKitsRoutes from "./views/ui-kits/uiKitsRoutes";
// import widgetsRoute from "./views/widgets/widgetsRoute";
// import dataTableRoute from "./views/data-table/dataTableRoute";
// import extraKitsRoutes from "./views/extra-kits/extraKitsRoutes";
// import chatRoutes from "./views/app/chat/chatRoutes";
// import inboxRoutes from "./views/app/inbox/inboxRoutes";
// import invoiceRoutes from "./views/app/invoice/invoiceRoutes";
// import contactRoutes from "./views/app/contact/contactRoutes";
// import calendarRoutes from "./views/app/calendar/calendarRoutes";
// import ecommerceRoutes from "./views/app/ecommerce/ecommerceRoutes";
// import taskManagerRoutes from "./views/app/task-manager/taskManagerRoutes";

// import Error404 from "./views/sessions/Error";
// import sessionsRoutes from "./views/sessions/sessionsRoutes";

// export const protectedRoutes = [
//   ...dashboardRoutes,
//   ...uiKitsRoutes,
//   ...formsRoutes,
//   ...widgetsRoute,
//   ...chartsRoute,
//   ...dataTableRoute,
//   ...extraKitsRoutes,
//   ...pagesRoutes,
//   ...iconsRoutes,
//   ...invoiceRoutes,
//   ...inboxRoutes,
//   ...calendarRoutes,
//   ...taskManagerRoutes,
//   ...ecommerceRoutes,
//   ...contactRoutes,
//   ...chatRoutes
// ];
// const routes = createBrowserRouter([
//   {
//     element: <AuthGuard />,
//     children: protectedRoutes
//   },
//   ...sessionsRoutes,
//   { path: "/", loader: () => redirect("/dashboard/v1") },
//   { path: "*", element: <Error404 /> }
// ]);

// export default routes;



import { createBrowserRouter, redirect } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";

import dashboardRoutes from "./views/dashboard/dashboardRoutes";
import pagesRoutes from "./views/pages/pagesRoutes";
import iconsRoutes from "./views/icons/iconsRoutes";
import formsRoutes from "./views/forms/formsRoutes";
import chartsRoute from "./views/charts/chartsRoute";
import uiKitsRoutes from "./views/ui-kits/uiKitsRoutes";
import widgetsRoute from "./views/widgets/widgetsRoute";
import dataTableRoute from "./views/data-table/dataTableRoute";
import extraKitsRoutes from "./views/extra-kits/extraKitsRoutes";
import chatRoutes from "./views/app/chat/chatRoutes";
import inboxRoutes from "./views/app/inbox/inboxRoutes";
import invoiceRoutes from "./views/app/invoice/invoiceRoutes";
import contactRoutes from "./views/app/contact/contactRoutes";
import calendarRoutes from "./views/app/calendar/calendarRoutes";
import ecommerceRoutes from "./views/app/ecommerce/ecommerceRoutes";
import taskManagerRoutes from "./views/app/task-manager/taskManagerRoutes";
import tenantsRoutes from "./views/tenants/tenantsRoutes";
import systemUserRoutes from "./views/system-users/systemUserRoutes";
import ModuleManagementPage from "./views/module-managment/modulemanagementRoutes";

import Error404 from "./views/sessions/Error";
import sessionsRoutes from "./views/sessions/sessionsRoutes";
import TenantsModuletRoutes from "./views/tenants-module/TenantsModuleRoutes";
import tenantlistRoutes from "./views/tenant-list/tenantlistRoutes";
import datasRoutes from "./views/dataTable/datasRoutes";

export const protectedRoutes = [
  ...dashboardRoutes,
  ...uiKitsRoutes,
  ...formsRoutes,
  ...widgetsRoute,
  ...chartsRoute,
  ...dataTableRoute,
  ...extraKitsRoutes,
  ...pagesRoutes,
  ...iconsRoutes,
  ...invoiceRoutes,
  ...inboxRoutes,
  ...calendarRoutes,
  ...taskManagerRoutes,
  ...ecommerceRoutes,
  ...contactRoutes,
  ...chatRoutes,
  ...tenantsRoutes,
  ...systemUserRoutes,
  ...ModuleManagementPage,
  ...TenantsModuletRoutes,
  ...tenantlistRoutes,
  ...datasRoutes
];

// 🔐 ROUTER
const routes = createBrowserRouter([
  {
    element: <AuthGuard />,
    children: protectedRoutes
  },

  ...sessionsRoutes,

  // 🔁 redirect home → dashboard
  {
    path: "/",
    loader: () => redirect("/dashboard/v1")
  },

  // ❌ fallback
  {
    path: "*",
    element: <Error404 />
  }
]);

export default routes;